import types from '../types';
import { getURLValueFromActiveInputs } from '.';

const normalizeURLValue = value => value.toString();

/**
 * @param {types.Filter[] | types.Select[]} filters
 * @returns {Object}
 */
const getURLParamsFromActiveFilters = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return {};
    }

    return filters.reduce((acc, curr) => {
        let value = null;

        switch (curr.type) {
            case 'checkbox':
                value = getURLValueFromActiveInputs(curr.options, curr.radio);
                break;

            case 'select':
                value = curr.value || null;
                break;

            default:
                value = null;
                break;
        }

        // ignore parameter if there is no value
        if (value === null) {
            return acc;
        }

        return {
            ...acc,
            [curr.id]: normalizeURLValue(value)
        };
    }, {});
};

export default getURLParamsFromActiveFilters;
